import React from "react";
import { ActionHandlerFunction, AdminDashboardUser } from "@preveil-api";
import { AdminUIActionTypes } from "src/common";
import { Icon, ToolbarButton, ToolbarWrapper, ToolbarFilter } from "src/components";

type AllProps = {
  is_loading: boolean;
  filter_param: string;
  users_list: AdminDashboardUser[];
  handleAction: ActionHandlerFunction;
}

// Description: Render the toolbar for the dashboard users table
function ToolbarComponent(props: AllProps) {
  const { filter_param, users_list, is_loading, handleAction } = props;

  return <ToolbarWrapper
    leftContent={<ToolbarFilter
      disabled={users_list.length === 0}
      filter_param={filter_param}
      onChange={(value) => handleAction({ actionType: AdminUIActionTypes.SearchParam, params: value })}
      onClick={() => handleAction({ actionType: AdminUIActionTypes.SearchParam })} />}
    refreshAction={() => handleAction({ actionType: AdminUIActionTypes.GetRefreshRequest })}
    refreshTooltipContent="Refresh Users"
    isLoading={is_loading}
  >
    <ToolbarButton
      onClick={() => handleAction({ actionType: AdminUIActionTypes.ExportCSV })}
      ariaLabel="Export User Storage"
      tooltipContent="Export User Storage">
      <Icon className="ficon-download" />
    </ToolbarButton>
  </ToolbarWrapper>;
}

export default React.memo(ToolbarComponent);
